// eslint-disable-next-line import/no-internal-modules
import * as addons from "addons/index";

export { addons };
export default addons;
